// Assign things to groups so that we can easily enable/disable collisions between different groups

import { makeCollisionGroups } from "../core/util/CollisionGroupUtils";
import { objectKeys } from "../core/util/ObjectUtils";

export const CollisionGroups = makeCollisionGroups([
  "Turret",
  "Enemy",
  "Bullet",
  "Bomb",
  "Explosion",
] as const);

export type CollisionGroupName = keyof typeof CollisionGroups;

const groupNames = objectKeys(CollisionGroups).filter((name) => name !== "All");

/**
 * Converts a collision group bitmask to an array of group names.
 * Useful for debugging or displaying which groups are active.
 */
export function collisionGroupToNames(group: number): CollisionGroupName[] {
  if (group === CollisionGroups.All) {
    return ["All"];
  }
  return groupNames.filter((name) => group & CollisionGroups[name]);
}

/**
 * Converts an array of collision group names to a combined bitmask.
 * Use this to create collision masks from multiple group names.
 */
export function collisionGroups(
  ...groups: ReadonlyArray<CollisionGroupName>
): number {
  return groups.reduce<number>(
    (acc, group) => acc | CollisionGroups[group],
    CollisionGroups.None,
  );
}
